import { observer } from 'mobx-react';
import type { IEmail } from '../../../stores/JobApplicationStore/Email';
import EmailItemMeta from './EmailItemMeta';
import EmailItemContent from './EmailItemContent';
import { Stack } from 'braid-design-system';
import type { Locale as MelwaysLocale } from '@seek/melways-sites';

interface Props {
  email: IEmail;
  locale: MelwaysLocale;
}

const EmailItem = ({ email, locale }: Props) => (
  <Stack space="gutter">
    <EmailItemMeta email={email} locale={locale} />
    <EmailItemContent email={email} />
  </Stack>
);

export default observer(EmailItem);
